module.exports = __webpack_public_path__ + "static/media/step-backward.6a33ae2d.svg";